const codeImageList = [{
    psl_Default_sample_consumables_code: '1',
    img: 'https://picture.aiyizhijian.com/image/jpg/647558719408112896.jpg',
    color: 'red',
    colorText: '红管',
    CuvetteType: 1
  },
  {
    psl_Default_sample_consumables_code: '2',
    img: 'https://picture.aiyizhijian.com/image/jpg/647558785384514816.jpg',
    color: 'yellow',
    colorText: '黄管',
    CuvetteType: 2
  },
  {
    psl_Default_sample_consumables_code: '3',
    img: 'https://picture.aiyizhijian.com/image/jpg/647558842536101120.jpg',
    color: 'purple',
    colorText: '紫管',
    CuvetteType: 3
  },
  {
    psl_Default_sample_consumables_code: '4',
    img: 'https://picture.aiyizhijian.com/image/png/647558897741530368.png',
    color: 'blue',
    colorText: '蓝管',
    CuvetteType: 4
  },
  {
    psl_Default_sample_consumables_code: '5',
    img: 'https://picture.aiyizhijian.com/image/png/647558949130142976.png',
    color: 'green',
    colorText: '绿管',
    CuvetteType: 5
  },
  {
    psl_Default_sample_consumables_code: '6',
    img: 'https://picture.aiyizhijian.com/image/jpg/647559007175116032.jpg',
    color: 'gray',
    colorText: '灰管',
    CuvetteType: 6
  },
  {
    psl_Default_sample_consumables_code: '7',
    img: 'https://picture.aiyizhijian.com/image/jpg/647559059587138816.jpg',
    color: 'black',
    colorText: '黑管',
    CuvetteType: 7
  },
  {
    psl_Default_sample_consumables_code: '8',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'Transparent',
    colorText: '透明管',
    CuvetteType: 8
  },
  {
    psl_Default_sample_consumables_code: '9',
    img: 'https://picture.aiyizhijian.com/image/jpg/647559166952932608.jpg',
    color: 'white',
    colorText: '白管',
    CuvetteType: 9
  },
  {
    psl_Default_sample_consumables_code: '10',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: '#0089ff',
    colorText: '粪便样本杯',
    CuvetteType: 10
  },
  {
    psl_Default_sample_consumables_code: '11',
    img: 'https://picture.aiyizhijian.com/image/png/647310128940778752.png',
    color: '#0089ff',
    colorText: '尿液样本杯',
    CuvetteType: 11
  },
  {
    psl_Default_sample_consumables_code: '12',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '无菌式子管',
    CuvetteType: 12
  },
  {
    psl_Default_sample_consumables_code: '13',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '无菌密封采样器',
    CuvetteType: 13
  },
  {
    psl_Default_sample_consumables_code: '14',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '专用采样器',
    CuvetteType: 14
  },
  {
    psl_Default_sample_consumables_code: '15',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '专用抗凝管',
    CuvetteType: 15
  },
  {
    psl_Default_sample_consumables_code: '16',
    img: 'https://picture.aiyizhijian.com/image/png/647310021503681792.png',
    color: 'white',
    colorText: '病理采样',
    CuvetteType: 16
  },
  {
    psl_Default_sample_consumables_code: '17',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '专用瓶',
    CuvetteType: 17
  },
  {
    psl_Default_sample_consumables_code: '18',
    img: 'https://picture.aiyizhijian.com/image/png/647309795342615808.png',
    color: '#0089ff',
    colorText: 'TCT耗材',
    CuvetteType: 18
  },
  {
    psl_Default_sample_consumables_code: '19',
    img: 'https://picture.aiyizhijian.com/image/png/647309642305045760.png',
    color: 'white',
    colorText: '肛/咽拭子',
    CuvetteType: 19
  },
  {
    psl_Default_sample_consumables_code: '20',
    img: 'https://picture.aiyizhijian.com/image/png/647309521416815872.png',
    color: '#0089ff',
    colorText: '玻片',
    CuvetteType: 20
  },
  {
    psl_Default_sample_consumables_code: '21',
    img: 'https://picture.aiyizhijian.com/image/png/647309387098424576.png',
    color: '#0089ff',
    colorText: '培养皿',
    CuvetteType: 21
  },
  {
    psl_Default_sample_consumables_code: '22',
    img: 'https://picture.aiyizhijian.com/image/png/647309189081138432.png',
    color: '#0089ff',
    colorText: '血培养瓶',
    CuvetteType: 22
  },
  {
    psl_Default_sample_consumables_code: '23',
    img: 'https://picture.aiyizhijian.com/image/png/647309086010311936.png',
    color: '#0089ff',
    colorText: 'HPV耗材',
    CuvetteType: 23
  },
  {
    psl_Default_sample_consumables_code: '24',
    img: 'https://picture.aiyizhijian.com/image/png/647308956469232896.png',
    color: '#0089ff',
    colorText: '女性拭子',
    CuvetteType: 24
  },
  {
    psl_Default_sample_consumables_code: '25',
    img: 'https://picture.aiyizhijian.com/image/png/647308819491652864.png',
    color: '#0089ff',
    colorText: '男性拭子',
    CuvetteType: 25
  },
  {
    psl_Default_sample_consumables_code: '26',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '红头BD管',
    CuvetteType: 26
  },
  {
    psl_Default_sample_consumables_code: '27',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '绿头BD管',
    CuvetteType: 27
  },
  {
    psl_Default_sample_consumables_code: '28',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '滤纸卡',
    CuvetteType: 28
  },
  {
    psl_Default_sample_consumables_code: '29',
    img: 'https://picture.aiyizhijian.com/image/png/647308292691264768.png',
    color: 'white',
    colorText: '混采专用采样器',
    CuvetteType: 29
  },
]

export default codeImageList;